var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window-frame',{attrs:{"titleText":"バージョン","display-property":"private.display.versionWindow","align":"center","fixSize":"500, 158"}},[_c('logo')],1)}
var staticRenderFns = []

export { render, staticRenderFns }